import ApplicationSerializer from "./application";

export default class ServerCostSerializer extends ApplicationSerializer {
  normalize(modelClass, resourceHash, prop) {
    resourceHash.id = crypto.randomUUID();

    return super.normalize(modelClass, resourceHash, prop);
  }
}
